
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/colors",
      function () {
        return require("private-next-pages/basic-elements/colors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/colors"])
      });
    }
  